import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import TableCell from 'src/components/Table/TableCell';
import StatusBadge from 'src/components/StatusBadge';
import ContractStatus from 'src/utils/constants/contracts';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';
import useStyles from './terminationKpiStyles';

const STATUS_TONES = {
  [ContractStatus.IN_PROGRESS]: 'success',
  [ContractStatus.ENDED]: 'neutral',
  [ContractStatus.CEDED]: 'info',
  [ContractStatus.CANCELLED]: 'error'
};

const getStatusTone = status => STATUS_TONES[status] || 'neutral';

const complianceLabel = (t, compliant) =>
  t(
    compliant
      ? 'CAPITAL_BALANCE.AUDIT_COMPLIANT'
      : 'CAPITAL_BALANCE.AUDIT_NON_COMPLIANT'
  );

const TerminationAuditRow = ({
  contractId,
  folio,
  status,
  terminationDate,
  balanceCompliant,
  termCompliant
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <TableRow hover>
      <TableCell align="left">
        <Link
          style={{ textDecoration: 'none' }}
          to={`/contracts/${contractId}`}
        >
          {folio}
        </Link>
      </TableCell>
      <TableCell align="left">
        <StatusBadge tone={getStatusTone(status)}>
          {t(`COMMON.${status}`)}
        </StatusBadge>
      </TableCell>
      <TableCell align="left">
        {selectFormatDate(terminationDate, dateFormatType.DAY)}
      </TableCell>
      <TableCell
        align="center"
        className={clsx(!termCompliant && classes.termMismatch)}
      >
        {complianceLabel(t, termCompliant)}
      </TableCell>
      <TableCell
        align="right"
        className={clsx(!balanceCompliant && classes.termMismatch)}
        sx={{ fontWeight: 'bold' }}
      >
        {complianceLabel(t, balanceCompliant)}
      </TableCell>
    </TableRow>
  );
};

TerminationAuditRow.propTypes = {
  contractId: PropTypes.number.isRequired,
  folio: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  terminationDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]).isRequired,
  balanceCompliant: PropTypes.bool.isRequired,
  termCompliant: PropTypes.bool.isRequired
};

export default TerminationAuditRow;
